import { Role } from '@/enums';
import { IOption } from '@/interfaces';
import { getRoleLabel } from '@/utils';

export const ROLE_OPTIONS: IOption[] = [
  {
    label: getRoleLabel(Role.Reviewer),
    value: Role.Reviewer,
  },
  {
    label: getRoleLabel(Role.SystemAdmin),
    value: Role.SystemAdmin,
  },
];
